import React from 'react';
import { StyleSheet, View } from 'react-native';

import { Color, CommonProperties } from '../styles';
import BaseText from './BaseText';

const InfoItem = (props) => {
  return (
    <View style={styles.container}>
      <BaseText style={styles.infoLabel}>{props.label}</BaseText>
      <BaseText style={styles.infoValue}>{props.value}</BaseText>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    ...CommonProperties.p3,
  },
  infoLabel: {
    color: Color.text.high,
    ...CommonProperties.body,
    ...CommonProperties.py2,
  },
  infoValue: {
    ...CommonProperties.body,
    ...CommonProperties.py1,
    color: Color.text.medium,
  },
});

export default InfoItem;
